<div class="page-container">
  <div class="page-content">
    <app-loading />
  </div>
</div>
